module.exports = __webpack_public_path__ + "media/images/shopping/complete/eyecatch-staff-03-03bf33f07e8e83565e7608b68fb1177e.svg";